import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Card from "components/card";
import InputField from "components/fields/InputField";
import config from "config";
import Loader from "react-spinners/PropagateLoader";
import Notification from "components/alert/Notification";
import TextEditor from "components/fields/TextEditor";
import {
    FaAngleLeft,
    FaTrash,
} from "react-icons/fa";
import {axiosInstance} from "../../../../utils/axiosInstance";
const EventForm = () => {
    const { id } = useParams();
    const [errorMessage, setErrorMessage] = useState("");
    const [message, setMessage] = useState("");
    const newsImageRef = useRef(null);
    const FilesRef = useRef(null);
    const [title, setTitle] = useState("");
    const [coverImage, setCoverImage] = useState(null);
    const [coverImageUrl, setCoverImageUrl] = useState(null);
    const [text, setText] = useState(null);
    const [readingTime, setReadingTime] = useState(0);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [galleryFiles, setGalleryFiles] = useState([]);

    const handleGalleryChange = (e) => {
        const selectedFiles = Array.from(e.target.files).map(file => ({
            data: file,
            preview: URL.createObjectURL(file),
        }));
        setGalleryFiles(prevFiles => [...prevFiles, ...selectedFiles]);
    };
    const removeGalleryItem = (fileToRemove) => {
        // Release the URL object
        URL.revokeObjectURL(fileToRemove.preview);
        setGalleryFiles(prevFiles => prevFiles.filter(file => file !== fileToRemove));
    };
    const handleEditorChange = (value) => {
        setText(value)
    }
    const handleErrorMessage = (text) => {
        setMessage('');
        setErrorMessage(text);
        window.scrollTo(0, 0);
    }
    const handleMessage = (text) => {
        setMessage(text);
        setErrorMessage('');
        window.scrollTo(0, 0);
    }
    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        handleErrorMessage("");
        if (title && coverImage && text) {
            const formData = new FormData();
            formData.append('Title', title);
            formData.append('Text', text);
            formData.append('CoverImage', coverImage);
            galleryFiles.map(item =>{
                formData.append('Files', item.data);
            });
            
            try {
                // if (id) { // if id would have existed -> edit mode

                //     const image = await fetch(coverImageUrl);
                //     // Step 2: Convert the image to a Blob
                //     const blob = await image.blob();
                //     formData.append('imgUp', blob);
                //     formData.append('Id', id)
                //     const response = await instance.post('api/AdminArticleApi/Update', formData, {
                //         headers: {
                //             'Content-Type': 'multipart/form-data'
                //         },
                //     });
                //     handleMessage("عملیات با موفقیت انجام شد.")
                //     setLoading(false);
                // }
                // else {
                    
                // }
                
                const response = await axiosInstance.post('api/AdminEvent/Create', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                });
                handleMessage("عملیات با موفقیت انجام شد.")
                setLoading(false);

            } catch (error) {

                console.log('error in set data :', error)
                setLoading(false);
                if (error.response && error.response.status === 400) {

                    handleErrorMessage(error.response.data);
                }
                else {
                    console.log("error in login : ", error);
                    handleErrorMessage("خطا در ارتباط با سرور");
                }
            }
        }
        else {
            setLoading(false);
            handleErrorMessage("فیلد های اجباری پر نشده اند");
        }
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setCoverImage(file);
            setCoverImageUrl(URL.createObjectURL(file));
        }
    };
    const handleButtonClick = () => {
        newsImageRef.current.click();
    };
    const handleGalleryClick = () => {
        FilesRef.current.click();
    };
    const closeNotif = () => {
        handleMessage('');
    }

    // useEffect(() => {
    //     const fetchNews = async (id) => {
    //         setLoading(true);
    //         try {
    //             const response = await instance.get(`api/Article/Detail?id=${id}`);
    //             const newsDetail = response.data;
    //             setTitle(newsDetail.title);
    //             setReadingTime(newsDetail.readingTime);
    //             setCoverImageUrl(config.NEWS_IMAGE_PATH + newsDetail.imageName);
    //             setText(newsDetail.description);
    //             setLoading(false);
    //         } catch (error) {
    //             console.error('Error fetching news:', error);
    //             setLoading(false);
    //         }
    //     };
    //     if (id) {
    //         fetchNews(id);
    //     }
    // }, [id])
    // Function to render file previews
    const renderPreviews = () => {
        return galleryFiles.map((file, index) => (
            <div key={index} className="relative group w-full transition-all bg-gray-200 rounded-lg flex justify-center items-center p-1 duration-300 hover:scale-105">
                <button type="button" onClick={() => removeGalleryItem(file)}
                    className="absolute hidden transition-all duration-500 rounded-lg group-hover:flex top-0 left-0 w-full h-full bg-red-400/40 text-white p-1 justify-center items-center z-10 shadow  ">
                        <FaTrash size="30"/>
                </button>
                {file.data.type.startsWith('image/') && (
                    <img
                        src={file.preview}
                        alt="Preview"
                        className=""
                    />
                )}
                {file.data.type.startsWith('video/') && (
                    <video src={file.preview} controls className="block w-full h-32 object-cover" />
                )}
            </div>
        ));
    };
    return (
        <Card extra={"w-full p-4 mt-8 flex justify-center"}>
            <div className="flex justify-end">
                <button onClick={() => navigate("/admin/events")}
                    className=" flex w-max items-center mt-4 px-6 p-3 rounded-xl gap-1 font-bold text-white dark:text-gray-800 text-md bg-cyan-500 hover:bg-cyan-600">
                    بازگشت
                    <FaAngleLeft className="  h-6 w-6" />
                </button>
            </div>
            {loading ?
                <Notification
                    text={<div className="flex gap-2 ">درحال دریافت اطلاعات،لطفا صبور باشید ...</div>}
                    type='success'
                />
                : null}
            <Notification
                text={errorMessage}
                type='error'
                closeNotification={() => setErrorMessage('')}
            />
            <Notification
                text={message}
                type='success'
                closeNotification={() => setMessage('')}
            />

            <form className="mt-4" onSubmit={handleSubmit}>
                {/* title */}
                <InputField
                    variant="event"
                    extra="mb-3 "
                    label="عنوان"
                    placeholder=""
                    id="title"
                    disabled={loading}
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    type="text"
                />
                {/* cover image */}
                <div className="flex flex-col gap-2 my-3">
                    <label className="text-sm  dark:text-white ml-3 font-bold">
                        تصویر کاور
                    </label>
                    <div className="flex bg-white  flex-col lg:flex-row gap-4 justify-between p-2 lg:px-6 items-center border rounded-xl">
                        <div className="w-full lg:w-1/2 order-2 lg:order-1">
                            <input
                                ref={newsImageRef}
                                accept="image/*"
                                id="image-upload"
                                type="file"
                                onChange={handleFileChange}
                                className="hidden"
                            />
                            <button
                                onClick={handleButtonClick}
                                className="flex items-center flex-col w-full h-full justify-center px-4 py-2 bg-blue-700 hover:bg-blue-800  text-white font-semibold rounded-lg shadow-md  focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75"
                                type="button"
                            >
                                {!coverImage ? " انتخاب عکس" : <p className="text-gray-300">{coverImage.name}</p>}
                            </button>
                        </div>
                        <div className="bg-gray-600 order-1 lg:order-2 w-full h-36 lg:w-40 rounded-xl">
                            <img className={`w-full h-full rounded-xl ${coverImageUrl ? '' : 'hidden'}`}
                                src={coverImageUrl}
                            />
                        </div>

                    </div>
                </div>
                {/* gallery */}
                <div className="flex flex-col gap-2 my-3">
                    <label className="text-sm  dark:text-white ml-3 font-bold">
                        گالری
                    </label>
                    <div className="grid md:grid-cols-6 grid-cols-1 h-full bg-white  gap-4 justify-between p-2 lg:px-6 items-center border rounded-xl">
                        <div className="col-span-2 w-full flex ">
                            {/* <input
                                type="file"
                                onChange={handleGalleryChange}
                                multiple
                                accept="image/*,video/*"
                            /> */}
                            <input
                            ref={FilesRef}
                                type="file"
                                onChange={handleGalleryChange}
                                multiple
                                accept="image/*,video/*"
                                className="hidden"
                            />
                            <button
                                onClick={handleGalleryClick}
                                className="flex items-center flex-col w-full h-12 justify-center px-4 py-2 bg-blue-700 hover:bg-blue-800  text-white font-semibold rounded-lg shadow-md  focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75"
                                type="button"
                            >
                                 افزودن محتوا
                            </button>
                        </div>
                        <div className="col-span-4 grid lg:grid-cols-5 grid-cols-1 h-full  w-full justify-center gap-2">{renderPreviews()}</div>

                    </div>
                </div>
                <div className="flex flex-col gap-1 justify-start mt-5 h-full ">
                    <label className="text-gray-800 text-sm mb-2 font-bold dark:text-white">متن رویداد</label>
                    <TextEditor onChange={handleEditorChange} initText={text} />
                </div>

                <button type="submit" className="linear mt-20 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200">
                    {loading ? <div className="h-5 flex items-center justify-center mb-2"><Loader loading="true" color="#fff" /></div> : "افزودن"}
                </button>

            </form>
        </Card>
    )
}

export default EventForm;